// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import {post, get, formData} from './api/axios.js'
import VueClipboard from 'vue-clipboard2'
import Tip from './common/tip/index.js'
import ChangeStaking from './components/changeStaking/index.js'
import './filter/filter.js'
import Meta from 'vue-meta'
Vue.use(Meta, {
  refreshOnceOnNavigation: true
})
Vue.config.productionTip = false
Vue.use(VueClipboard)
Vue.prototype.$tip = Tip
Vue.prototype.$ChangeStaking = ChangeStaking
Vue.prototype.post = post
Vue.prototype.get = get
Vue.prototype.formData = formData
/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
export default vue



// WEBPACK FOOTER //
// ./src/main.js